export default {
    reserveClick: ({commit, getters}) => {
        if (!getters.isFewerParticipantsThanSelectedMaxCapacity) {
            commit(
                "setErrorMessageOpen",
                'errorMessages_notEnoughPrestationsSelected'
            )
        } else {
            window.location.href = getters.bookingProcessURL
        }
    },
}